import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import React, { useEffect } from 'react';

const SectionSelectModal = ({
  open,
  handleClose,
  sections = [],
  selectedGuids = [],
  onSubmit,
  loading = false,
}) => {
  const [checked, setChecked] = React.useState([]);

  useEffect(() => {
    if (open) {
      setChecked(selectedGuids);
    }
    // Sync selection only when the modal opens
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleToggle = value => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>لطفا طبقه مورد نظر را انتخاب کنید</DialogTitle>

      <DialogContent dir="rtl">
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {sections.length === 0 ? (
            <Typography sx={{ textAlign: 'center', color: '#9EADB4' }}>
              طبقه‌ای برای انتخاب وجود ندارد
            </Typography>
          ) : (
            <List
              sx={{
                width: '100%',
                bgcolor: 'background.paper',
                direction: 'rtl',
              }}
            >
              {sections.map(section => {
                const labelId = `checkbox-list-label-${section.guid}`;
                const sectionId = section.guid;
                return (
                  <ListItem
                    key={sectionId}
                    disablePadding
                    sx={{ direction: 'rtl' }}
                  >
                    <ListItemButton
                      role={undefined}
                      onClick={handleToggle(sectionId)}
                      dense
                      sx={{ direction: 'rtl', textAlign: 'right' }}
                    >
                      <ListItemIcon sx={{ minWidth: 42 }}>
                        <Checkbox
                          edge="start"
                          checked={checked.includes(sectionId)}
                          tabIndex={-1}
                          disableRipple
                          slotProps={{ input: { 'aria-labelledby': labelId } }}
                        />
                      </ListItemIcon>
                      <ListItemText id={labelId} primary={section.display} />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button onClick={handleClose} variant="contained" disabled={loading}>
          انصراف
        </Button>
        <LoadingButton
          color="warning"
          variant="contained"
          onClick={() => onSubmit(checked)}
          loading={loading}
        >
          تأیید
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default SectionSelectModal;
